import { create } from "zustand";

interface InterviewPopupState {
  isOpen: boolean;
  interviewId: string | null;
  participantName?: string;
  jumpToTimestamp?: number;
  quoteText?: string; // For precise word-level seeking
}

interface InterviewPopupActions {
  openPopup: (data: {
    interviewId: string;
    participantName?: string;
    jumpToTimestamp?: number;
    quoteText?: string;
  }) => void;
  closePopup: () => void;
  resetPopup: () => void;
}

type InterviewPopupStore = InterviewPopupState & InterviewPopupActions;

const initialState: InterviewPopupState = {
  isOpen: false,
  interviewId: null,
  participantName: undefined,
  jumpToTimestamp: undefined,
  quoteText: undefined,
};

export const useInterviewPopupStore = create<InterviewPopupStore>((set) => ({
  ...initialState,

  openPopup: (data) => {
    set({
      isOpen: true,
      interviewId: data.interviewId,
      participantName: data.participantName,
      jumpToTimestamp: data.jumpToTimestamp,
      quoteText: data.quoteText,
    });
  },

  closePopup: () => {
    set({
      isOpen: false,
      // Clear jump parameters to prevent stale highlights when reopening
      jumpToTimestamp: undefined,
      quoteText: undefined,
    });
  },

  resetPopup: () => {
    set(initialState);
  },
}));
